
export class MasterHelpModel {
    Id: number;
    PageName:string;
    HelpContent:string;
    StepId:number;
    DisplayContent:boolean;
    UserId:number;
}